<template>
	<v-container>
		<btn-a
			class="ma-2"
			outlined
			rounded
			color="primary"
			@click="regTypeFieldDialogOpen"
		>
			<v-icon>mdi-plus</v-icon>
		</btn-a>
		<v-list two-line subheader v-if="value.regTypeFields">
			<div v-for="(item, i) in value.regTypeFields" :key="i">
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title v-text="item.label"></v-list-item-title>
					</v-list-item-content>
					<v-list-item-action>
						<v-btn icon @click="regTypeFieldDialogOpen(item)">
							<v-icon color="warning">mdi-pencil</v-icon>
						</v-btn>
					</v-list-item-action>
					<v-list-item-action>
						<v-btn icon @click="regTypeFieldRemove(item)">
							<v-icon color="error">mdi-delete</v-icon>
						</v-btn>
					</v-list-item-action>
				</v-list-item>
				<v-divider
					v-if="value.regTypeFields && value.regTypeFields.length > 0"
				></v-divider>
			</div>
		</v-list>
		<dialog-d
			ref="regTypeFieldDialog"
			title="Reg Type Field"
			@confirm="regTypeFieldConfirm"
			@cancel="jobStageStatusDialogCancel"
		>
			<regTypeFieldForm ref="form" v-model="regTypeFieldSelected" />
		</dialog-d>
	</v-container>
</template>

<script>
	import regTypeFieldForm from "./regTypeFieldForm";

	export default {
		components: { regTypeFieldForm },
		props: {
			value: {
				default: () => {
					return {
						description: "",
						regTypeField: [],
						jobStageStatus: [],
						calendarProds: [],
						calendarExcs: [],
					};
				},
			},
		},
		data() {
			return {
				regTypeFieldSelected: {},
				regTypeFieldSelectedRef: null,
			};
		},

		methods: {
			jobStageStatusDialogCancel() {
				this.regTypeFieldSelectedRef = null;
			},
			regTypeFieldConfirm() {
				if (!this.$refs.form.isValid()) return;
				if (this.regTypeFieldSelectedRef) {
					Object.assign(
						this.regTypeFieldSelectedRef,
						this.regTypeFieldSelected
					);
				} else {
					this.value.regTypeFields.push(this.regTypeFieldSelected);
				}
				this.$refs.regTypeFieldDialog.open();
				this.regTypeFieldSelectedRef = null;
			},
			async regTypeFieldRemove(regTypeField) {
				if (!(await this.$confirm())) return;
				let index = this.value.regTypeFields.indexOf(regTypeField);
				if (index >= 0) this.value.regTypeFields.splice(index, 1);
			},
			regTypeFieldDialogOpen(regTypeField) {
				if (regTypeField) {
					this.regTypeFieldSelectedRef = regTypeField;
					let obj = {};
					Object.assign(obj, regTypeField);
					this.regTypeFieldSelected = obj;
				} else {
					this.regTypeFieldSelected = { combo: [] };
				}

				this.$refs.regTypeFieldDialog.open();
			},
		},
	};
</script>
